<template>
  <generic-modal
    v-if="showModal"
    @close="closeModalM()"
    :height="menuModalDim.height"
    :width="menuModalDim.width"
    :modalClass="menuModalDim.modalClass"
    :bottom="menuModalDim.bottom"
    :padding="menuModalDim.padding"
    :maxHeight="menuModalDim.maxHeight"
    :genericModalSource="'bottomBarMenu'"
  >
    <template v-slot:header>
      <div></div>
    </template>
    <template v-slot:body>
      <div class="menu-pop-content">
        <ul
          v-for="(item, index) in getCategoryNameAndCountForBottomBar"
          v-bind:key="item.categoryName"
        >
          <li
            class="mb16 cursor-pointer"
            :class="{
              // disabled: getCategoryNameAndCountForBottomBar[index].count == 0,
              // bgGrey: selectedMenuItem == item.categoryName,
            }"
            :ref="
              item.categoryName === selectedMenuItem ? 'selectedItem' : null
            "
            @click="goto(item, index)"
            v-if="
              item.visible &&
              getCategoryNameAndCountForBottomBar[index].count != 0
            "
          >
            <div class="d-flex justify-content-between plr16">
              <div
                class="fs-14"
                :class="{
                  highlightText: selectedMenuItem == item.categoryName,
                }"
              >
                {{ item.categoryName }}
              </div>
              <div
                class="fs-14"
                :class="{
                  highlightText: selectedMenuItem == item.categoryName,
                }"
              >
                {{ item.count }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </generic-modal>
</template>
<script>
import GenericModal from "./GenericModal.vue";
import { keyMapsGetter, keyMapsMutation } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import {
  imgBaseUrl,
  staticImgBaseUrl,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import localStorageFunc from "../helpers/localStorageFunc";
import {
  EVENT_CLICK_CATEGORY_BOTTOM_STICKY_MENU,
  EVENT_MENU_CATEGORY_FLOATER,
} from "../helpers/analyticsEvents";

export default {
  name: "BottomBarMenuModal",
  components: {
    GenericModal,
  },
  props: {
    showModal: { type: Boolean, default: false },
    menuModalDim: {
      type: Object,
      default: {
        width: "255px",
        height: "fit-content",
        maxHeight: "234px",
        bottom: "20px",
        modalClass: "menu-modal",
        padding: "0px !important",
      },
    },
  },
  data() {
    return {
      staticImgBaseUrl: staticImgBaseUrl,
      imgBaseUrl: imgBaseUrl,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.watchSelectedMenuItem();
    });
    this.scrollToSelected();
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchSelectedMenuItem);
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.scrollToSelected();
        });
      }
    },
  },
  methods: {
    watchSelectedMenuItem() {
      if (
        window.pageYOffset < 50 &&
        !this.selectedMenuItem?.startsWith("undefined")
      ) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_MENU_ITEM,
          "undefined"
        );
      }
    },
    scrollToSelected() {
      this.$nextTick(() => {
        let el = this.$refs.selectedItem;
        if (!el) return;
        if (Array.isArray(el)) el = el[0];
        if (!el) return;
        const scrollContainer = this.$el.querySelector(
          ".categories-menu-modal .modal-container"
        );
        if (!scrollContainer) return;

        const elTop = el.offsetTop;
        const elHeight = el.offsetHeight;
        const containerHeight = scrollContainer.clientHeight;

        const scrollTopTarget = elTop - containerHeight / 2 + elHeight / 2;

        scrollContainer.scrollTo({
          top: scrollTopTarget,
          behavior: "smooth",
        });
      });
    },
    closeModalM(crossClicked = false) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$emit("close-menu-modal");
    },
    scrollToCategoryId(item, url) {
      if (item) {
        const categoryId = item?.nodeId || "menuTop";
        url = Utility.addUpdateParam(url, "showSearchModal", false);
        return Utility.addUpdateParam(url, "scrollTo", categoryId);
      }
      return url;
    },
    goto(item, index) {
      this.closeModalM();
      const { nodeId, categoryName, count } = item;
      EVENT_MENU_CATEGORY_FLOATER({
        userAction: "category selected",
        sectionName: "menu category floater",
        positionWithinSection: index + 1,
        category: categoryName,
      });
      EVENT_CLICK_CATEGORY_BOTTOM_STICKY_MENU({ subCategory: item.nodeName });

      // Early return if no count or nodeId
      if (!nodeId || !count) return;

      // Trigger filter reset
      this.$store.commit(keyMapsMutation.TRIGGER_FILTER_REF, {});

      // Set the category name and product counter string
      this.$store.commit(
        keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS,
        true
      );
      this.$store.commit(
        keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
        categoryName
      );
      this.$store.commit(
        keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
        categoryName
      );

      // After DOM updates, scroll to the category and close the modal
      this.$nextTick(() => {
        Utility.scrollUptoTo(
          "element_catg_" + nodeId,
          this.getScrollTopMargin()
        );
        this.closeModalM(false, categoryName, false);
      });
    },
    // goto(item) {
    //   this.closeModalM();
    //   EVENT_CLICK_CATEGORY_BOTTOM_STICKY_MENU({ subCategory: item.nodeName });
    //   let url =
    //     projectBasePathWithFolder +
    //     "/menu/" +
    //     localStorageFunc.storeId() +
    //     Utility.getUrlQueryString();
    //   url = this.scrollToCategoryId(item, url);
    //   window.location.href = url;
    // },
  },
  computed: {
    getCategoryNameAndCountForBottomBar() {
      let productItems =
        this.$store.getters[
          keyMapsGetter.GET_CATEGORY_NAME_AND_COUNT_FOR_BOTTOM_BAR
        ];
      return productItems;
    },
    selectedMenuItem() {
      return this.$store.state.Menu.clickedCategoryAnchorLink;
    },
  },
};
</script>
